import { post } from "../../utils/backend";
import { useLongfansMock } from "../../global/GlobalMock";
import { mockCheckSpaceExists } from "./HomeMock";

const ping = (): Promise<Record<string, unknown> | string> =>
  post<Record<string, never>, Record<string, unknown>>("/api/ping", {});

const checkSpaceExists = async (spaceId: string): Promise<boolean> => {
  if (useLongfansMock) {
    return mockCheckSpaceExists(spaceId);
  }
  const res = await post<{ spaceId: string }, { exists: boolean }>(
    "/lark/app/space/checkSpaceExists",
    { spaceId },
    { silent: true }
  );
  if (typeof res === "string") {
    return false;
  }
  return !!res?.exists;
};

export const HomeApi = {
  ping,
  checkSpaceExists,
};
